<template class="custom-container-bg">
  <div>
    <data-list :payload="modelObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination" class="sortableRow" ref="sortableTable">
      <template slot="filterForm">
        <v-layout row class="pa-3 ma-0">
          <v-flex lg2 md2>
            <v-btn  color="primary" :to="`/${this.MODULE_URL}/actions`" dark>{{ $t('message.common.new') }}</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex lg3 md4 class="text-right">
            <v-text-field append-icon="search" outlined dense hide-details single-line v-model="search" :label="$t('message.common.search')" id="searchbtn"></v-text-field>
          </v-flex>
        </v-layout>
      </template>
    </data-list>
  </div>
</template>
<script>
import DataList from '@/components/DataList.vue'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      MODULE_URL: 'return_forms',
      modelObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        isDeviation: true,
        addNewRoute: () => this.$router.push(`/${this.MODULE_URL}/actions`),
        list: [],
        loading: true,
        editProp: 'companyname',
        editURL: (item) => `/${this.MODULE_URL}/actions/${item.id}`,
        statusColor: 'deviationstatuslist_name',
        applyColor: 'deviationstatuslist_color',
        actionsList: [{
          click: (item) => this.getDeviationReport(item.id),
          icon: (item) => 'mdi-download',
          is_show: (item) => true,
          color: (item) => '#eb5f0a'
        }],
        hasFilters: true
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.DEVIATION_INDEX) ? this.$store.state.DEVIATION_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      yearFilterOnCategory: moment().year(),
      yearFilterOnLocation: moment().year(),
      monthFilterOnCategory: moment().month(),
      monthFilterOnLocation: moment().month(),
      search: '',
      // listOfDevationStatus: [],
      showStatistics: false,
      reportData: [],
      filterByStatusId: 0,
      categoryChartData: {},
      locationChartData: {}
    }
  },
  components: {
    DataList
  },
  computed: {
    ...mapState(['DEVIATION_INDEX', 'listOfDevationStatus']),
    headers () {
      return [{
        text: this.$t('message.returnForm.companyName'),
        value: 'companyname'
      }, {
        text: this.$t('message.layout.deviation'),
        value: 'deviation_number'
      }, {
        text: `${this.$t('message.returnForm.companyNo')}`,
        value: 'companynumber'
      }, {
        text: this.$t('message.customer.email'),
        value: 'email'
      }, {
        text: this.$t('message.customer.mobile'),
        value: 'mobile'
      }, {
        text: this.$t('message.productionOrder.winNumbers'),
        value: 'win_numbers'
      }, {
        text: this.$t('message.customer.description'),
        value: 'description'
      }]
    },
    chartData () {
      return {
        chart: {
          type: 'bar'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
          minPadding: 0,
          maxPadding: 0
        },
        navigation: {
          buttonOptions: {
            enable: true
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Values',
            style: { 'font-size': '14px' }
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        credits: false,
        series: []
      }
    }
  },
  created () {
    this.$store.dispatch('getDeviationStatus')
  },
  watch: {
    yearFilterOnCategory (val) {
      this.getCategoryChart()
    },
    yearFilterOnLocation (val) {
      this.getLocationChart()
    },
    monthFilterOnCategory (val) {
      this.getCategoryChart()
    },
    monthFilterOnLocation (val) {
      this.getLocationChart()
    },
    search (val) {
      this.pagination.search = val
      this.debouncedGetSearchResults()
    },
    pagination (val) {
      const model = { type: 'DEVIATION_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.debouncedGetSearchResults()
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        const payload = { ids: data.ids, url: 'returnform/delete_multiple', module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.modelObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.debouncedGetSearchResults = this.$formatter.debounce(this.getListHandler, 300)
  },
  methods: {
    yearListOnCategory () {
      let currentYear = this.yearFilterOnCategory ? this.yearFilterOnCategory : moment().year()
      const list = [currentYear === moment().year() ? currentYear : currentYear++, currentYear, currentYear--, currentYear--, currentYear--, currentYear--]
      return list.reverse()
    },
    yearListOnLocation () {
      let currentYear = this.yearFilterOnLocation ? this.yearFilterOnLocation : moment().year()
      const list = [currentYear === moment().year() ? currentYear : currentYear++, currentYear, currentYear--, currentYear--, currentYear--, currentYear--]
      return list.reverse()
    },
    monthListOnCategory () {
      return this.getMonthsName()
    },
    monthListOnLocation () {
      return this.getMonthsName()
    },
    getMonthsName () {
      const lang = this.$i18n.locale === 'en' ? 'en' : 'nb'
      const list = moment.localeData(lang).months()
      const monthNames = []
      list.forEach((element, index) => {
        monthNames.push({ id: index, name: element })
      })
      return monthNames
    },
    getListHandler () {
      const statusFilterString = this.filterByStatusId ? `status_id eq ${this.filterByStatusId}` : ''
      const statusFilter = []
      if (statusFilterString) {
        statusFilter.push(statusFilterString)
      }
      this.modelObj.loading = true
      this.modelObj.module = this.MODULE_URL
      const fields = this.$formatter.cloneVariable(this.headers)
      fields.splice(1, 1)
      const queryFields = fields
      const { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const result = queryFields.find(x => x.value === sortBy[0])
      const pageVal = page || 1
      const query = {
        expand: [{
          select: ['number'],
          model: 'Deviation',
          on_field: 'id',
          on_parent_field: 'deviation_id',
          filter: `number contains '${search}'`,
          order_by: {
            field: sortBy[0] === 'deviation_number' ? 'number' : null,
            asc_or_desc: sortBy[0] === 'deviation_number' ? sortDesc[0] ? 'desc' : 'asc' : null
          }
        }],
        order_by: {
          field: result ? result.value : '',
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`,
        additionalfilters: statusFilter
      }
      this.$_executeApi('post', 'returnform/query', query)
        .then((response) => {
          const { values, count } = response.data
          this.modelObj.loading = false
          const transformData = { date: { list: ['created_on', 'deadline'], from: 'DD.MM.YYYYTHH:mm:ss', to: 'DD.MM.YYYY' }, arrayStringJoin: { list: ['win_numbers'] } }
          const model = this.$_formatListModel(values, transformData)
          this.modelObj.list = model
          this.total = count
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
